import { commonFilter } from './filter';

const pageId = '20022';

export default {
  pageName: 'Overview',
  pageId,
  pagePath: '/opinion/Overview',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    TK_keyword: {
      buttonId: '200220',
    },
    TK_sentimentTab: {
      buttonId: '200221',
    },
    TK_translate: {
      buttonId: '200222',
    },
    GPT_Get_Btn: {
      buttonId: '200223',
    },
    GPT_Confirm: {
      buttonId: '200224',
    },
    ...commonFilter,
  },
};
